var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2646 0.636353C13.6214 0.636353 12.2894 1.9684 12.2894 3.61156V5.09916H9.31418V8.07437C9.31418 8.89595 9.98021 9.56197 10.8018 9.56197H22.7026C23.5242 9.56197 24.1902 8.89595 24.1902 8.07437V5.09916H21.215V3.61156C21.215 1.9684 19.883 0.636353 18.2398 0.636353H15.2646ZM15.2646 5.09916C15.2646 4.27758 15.9306 3.61156 16.7522 3.61156C17.5738 3.61156 18.2398 4.27758 18.2398 5.09916C18.2398 5.92074 17.5738 6.58677 16.7522 6.58677C15.9306 6.58677 15.2646 5.92074 15.2646 5.09916Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8638 14.2727H12.9092V18.3636H14.2728V19.0454H10.8638V18.3636H12.2274V14.9545H10.8638V14.2727Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0456 14.2727H23.8183V14.9545H19.0456V14.2727Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8183 16.3182V14.9545H24.5001V16.3182H23.8183Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7274 17V16.3182H23.8183V17H19.7274Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7274 17V18.3636H24.5001V19.0454H19.0456V17H19.7274Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2729 23.1364H10.182V23.8182H14.2729V25.1818H11.5456V25.8636H14.2729V27.2273H10.182V27.9091H14.2729V27.2273H14.9547V25.8636H14.2729V25.1818H14.9547V23.8182H14.2729V23.1364Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0456 23.1364H19.7274V25.1818H19.0456V23.1364ZM19.7274 25.1818H23.1365V23.1364H23.8183V28.5909H23.1365V25.8636H19.7274V25.1818Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36377 6.58677H7.82658V8.07437C7.82658 9.71753 9.15862 11.0496 10.8018 11.0496H22.7026C24.3458 11.0496 25.6778 9.71753 25.6778 8.07437V6.58677H30.1406V33.3636H3.36377V6.58677ZM8.81832 12.9091H16.3183V20.4091H8.81832V12.9091ZM17.682 12.9091H25.182V20.4091H17.682V12.9091ZM16.3183 21.7727H8.81832V29.2727H16.3183V21.7727ZM17.682 21.7727H25.182V29.2727H17.682V21.7727Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7273,
    height: 32.7273,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreReport);
export default __webpack_public_path__ + "static/media/ScoreReport.155318b5549d198635856a1d7c3e44a0.svg";
export { ForwardRef as ReactComponent };